import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptor,
} from '@angular/common/http';
import { v4 as uuidv4 } from 'uuid';
import { environment } from './../../../../environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { SettingsService } from '../services/Authentication/settings.service';
import { AppConst } from '@app/App.const';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private settingServie: SettingsService,
    private oauthService: OAuthService
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const isMicrosoftGraphRequest = request.url.includes(
      'https://graph.microsoft.com/v1.0/users'
    );
    const isApplicationApiRequest =
      request.url.includes(environment.baseAPIEndpoint) ||
      isMicrosoftGraphRequest;
    const regionSelectionIncomplete =
      environment.isBaseApplication &&
      this.settingServie.isUserLoggedin() &&
      sessionStorage.getItem(AppConst.REGION_SELECTION_COMPLETED) !== 'true';
    if (
      isApplicationApiRequest &&
      regionSelectionIncomplete &&
      !this.isRegionSelectionApiRequest(request)
    ) {
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 403,
            statusText: 'Forbidden',
            url: request.url,
            error: {
              message: 'Select a region before accessing application APIs.',
            },
          })
      );
    }

    const isHandoffExchange = request.url.includes(
      '/authorization/region-handoff/exchange'
    );
    if (
      request.url.includes(environment.baseAPIEndpoint) ||
      isMicrosoftGraphRequest
    ) {
      const bearerToken = isMicrosoftGraphRequest
        ? this.settingServie.getToken()
        : this.oauthService.getAccessToken();
      let sessionId = sessionStorage.getItem(AppConst.SESSION_ID_KEY);
      sessionId = sessionId ? sessionId : '';
      const headers: Record<string, string> = {
        'X-Correlation-ID': uuidv4(),
      };
      if (!isHandoffExchange) {
        headers['Authorization'] = `Bearer ${bearerToken}`;
        headers['session-id'] = sessionId;
      }
      request = request.clone({
        setHeaders: headers,
      });
    }
    return next.handle(request).pipe(
      catchError((error: any) => {
        const sessionErrorMessage = error?.error?.message ?? error?.error;
        if (
          error?.status === 401 &&
          ['Invalid sessionId!', 'Invalid Session ID'].includes(
            sessionErrorMessage
          )
        ) {
          this.settingServie.handleInvalidSessionIdError();
        }
        return throwError(() => error);
      })
    );
  }

  private isRegionSelectionApiRequest(
    request: HttpRequest<unknown>
  ): boolean {
    const path = request.url.split(/[?#]/, 1)[0];
    if (request.method === 'GET') {
      return (
        /\/authorization\/currentUserDetails\/?$/.test(path) ||
        /\/authorization\/user\/[^/]+\/regions\/?$/.test(path) ||
        /\/authorization\/region-handoff\/csrf\/?$/.test(path)
      );
    }

    return (
      request.method === 'POST' &&
      /\/authorization\/region-handoff\/?$/.test(path)
    );
  }
}
